<template>
    <v-dialog v-model="dialog" max-width="500">
        <template v-slot:activator="{ on }">
            <v-btn  text v-on="on">
                <v-icon>{{icons.plus}}</v-icon> Add Contact
            </v-btn>
        </template>
        <v-card>
            <v-card-title>Quick Add Contact</v-card-title>
            <v-card-text>
                <v-form v-model="valid" ref="form" lazy-validation >
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                    outlined
                                    label="First Name, Last Name"
                                    v-model="contactinfo.name"
                                    :rules="[$store.state.rules.nameRules]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                    outlined
                                    label="Nickname"
                                    v-model="contactinfo.nickname"
                                    :rules="[$store.state.rules.nameRules]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                    outlined
                                    label="Cell"
                                    v-model="contactinfo.cell"
                                    clearable
                                    counter
                                    type="number"
                                    :rules="[$store.state.rules.cellRules]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                    outlined
                                    label="E-mail"
                                    v-model="contactinfo.email"
                                    :rules="[$store.state.rules.emailRules]"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="dialog=false,contactinfo={}">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click="saveContact" :loading="loading" :disabled="!valid">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'

  export default {
    name: "QuickAdd",
    components: {},
    data() {
      return {
        dialog:false,
        contactinfo:{},
        valid:false,
        loading:false
      }
    },
    computed: {
      ...mapState(['icons','org'])
    },
    methods: {
      ...mapActions(['get', 'post']),
      ...mapMutations(['appendContact']),
      async saveContact() {
        let body = {
          'name': this.contactinfo.name || null,
          'cell': this.contactinfo.cell || null,
          'email': this.contactinfo.email || null,
          'nickname': this.contactinfo.nickname || null,
          'instagram': this.contactinfo.instagram || null,
          'orgtkey' : this.$store.state.org.partkey,
          'id': this.contactinfo.id || null,
          'status': 'active'
        }
        this.loading=true;
        let res = await this.post({path:'api/contacts/editcontactv3',body:body})
        this.loading=false
        this.appendContact(res.info)
        this.$emit('newcontact',res.info)
        this.dialog=false
      },
    }
  }
</script>

<style scoped>

</style>